export async function getSavedApplicationList({ request }) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/get_saved_application_list?request=${encodeURIComponent(request)}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: "",
    }
  );

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    return Promise.reject(errorData?.detail || "Failed to fetch saved applications");
  }

  return res.json();
}
